import { render, staticRenderFns } from "./CABinding.vue?vue&type=template&id=efee010e&scoped=true&"
import script from "./CABinding.vue?vue&type=script&lang=js&"
export * from "./CABinding.vue?vue&type=script&lang=js&"
import style0 from "./CABinding.vue?vue&type=style&index=0&id=efee010e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efee010e",
  null
  
)

export default component.exports